import { IS_DEBUG } from '@/constants'
import { IS_PRELIVE, IS_PROD } from '@/utils/constants'

import mixpanel from 'mixpanel-browser'

function stringifyNonPrimitives<T>(input: T, depth: number = 0, maxDepth: number = 2): T {
  if (input === null || input === undefined) return input
  if (typeof input !== 'object') return input

  if (Array.isArray(input)) {
    return input.map((item) => stringifyNonPrimitives(item, depth, maxDepth)) as T
  }

  return Object.fromEntries(
    Object.entries(input).map(([key, value]) => {
      if (typeof value === 'bigint') {
        return [key, value.toString()]
      }
      if (typeof value === 'function') {
        return [key, value.toString()]
      }
      if (typeof value === 'object' && value !== null) {
        try {
          return depth < maxDepth
            ? [key, stringifyNonPrimitives(value, depth + 1, maxDepth)]
            : [key, JSON.stringify(value)] // Stringify if max depth reached
        } catch {
          return [key, {}]
        }
      }
      return [key, value]
    })
  ) as T
}

export const getGlobalData = () => {
  return {
    userAgent: navigator?.userAgent,
    platform: navigator?.platform,
    language: navigator?.language,
    screenSize: `${window.screen.width}x${window.screen.height}`,
    viewportSize: `${window.innerWidth}x${window.innerHeight}`,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    url: window.location.href,
  }
}

export const sendLog = (
  {
    message,
    tags,
    data,
  }: {
    message: string
    tags: string
    data?: string | object | undefined
  },
  globalData?: any
) => {
  try {
    // window._LTracker?.push({
    //   ...globalData,
    //   text: message,
    //   anObject: stringifyNonPrimitives(data),
    //   tags: tags || message || '', // a or a,b
    // })
    if (IS_PROD || IS_PRELIVE || IS_DEBUG) {
      const payload = {
        ...getGlobalData(),
        ...globalData,
        text: message,
        anObject: stringifyNonPrimitives(data),
        tags: tags || message || '', // a or a,b
      }
      // axios.post(
      //   `${import.meta.env.VITE_LOG_URL}/inputs/cc93a41f-7495-42ef-9ce9-08434348fb1d/tag/loggly-jslogger`,
      //   payload
      // )
      mixpanel.track(message, payload)
    } else console.log(message, data)
  } catch {}
}

window.addEventListener('error', (event) => {
  sendLog({
    message: 'Unhandled Error',
    data: {
      message: event.error?.message,
      stack: event.error?.stack,
      filename: event?.filename,
      lineno: event?.lineno,
      colno: event?.colno,
    },
    tags: 'global-error',
  })
})

window.addEventListener('unhandledrejection', (event) => {
  sendLog({
    message: 'Unhandled Promise Rejection',
    data: {
      message: event?.reason?.message || String(event?.reason),
      stack: event?.reason?.stack,
    },
    tags: 'global-unhandledrejection',
  })
})
